<i18n src="@/locales/modules/RequestTypeTranslate.json"></i18n>

<template>
	<el-dialog
		append-to-body
		class="custom-nested-dialog request-type-statistical-expression-form-dialog"
		:visible.sync="isDialogActiveLocal"
		:before-close="handleBeforeCloseDialog"
		:title="$t(`${value.id ? 'UpdateStatisticalExpression' : 'CreateStatisticalExpression'}`)"
	>
		<PerfectScrollbar>
			<form
				class="request-type-statistical-expression-form-dialog__form p-6"
				autocomplete="off"
				@submit.prevent
			>
				<div class="mb-5">
					<legend class>{{ $t("ExpressionName") }}<span class="text-danger">&nbsp;*</span>:</legend>
					<cbs-input
						name="name"
						class="inputx w-full"
						v-model="value.name"
						v-validate="'required'"
						:data-vv-as="$t('ExpressionName')"
						:placeholder="`${$t('Actions.Input')} ${$t('ExpressionName').toLowerCase()}`"
					/>
					<span class="text-danger text-sm">{{ errors.first("name") }}</span>
				</div>

				<div class="mb-5">
					<legend class>{{ $t("ExpressionType") }}<span class="text-danger">&nbsp;*</span>:</legend>
					<v-select
						name="type"
						label="value"
						v-validate="'required'"
						v-model="value.typeId"
						:reduce="type => type.key"
						:options="statisticalExpressionTypes"
						:data-vv-as="$t('ExpressionType')"
						:placeholder="`${$t('Actions.Choose')} ${$t('ExpressionType').toLowerCase()}`"
					>
						<span slot="no-options">{{ $t("Notify.NoMatchingOptions") }}</span>
					</v-select>
					<span class="text-danger text-sm">{{ errors.first("type") }}</span>
				</div>

				<div>
					<legend class="flex justify-between items-center">
						<div>
							{{ $t("Expression") }}<span class="text-danger">&nbsp;*</span>:
						</div>
						<cbs-hint :data="$t('CalculationHint')" />
					</legend>
					<CalculatorFieldConfig
						name="calculation"
						v-validate="'required'"
						v-model="value.expression"
						:listFields="formFields"
						:data-vv-as="$t('Expression')"
						:placeholder="`${$t('Actions.Input')} ${$t('Expression').toLowerCase()}`"
					>
						<template slot="error">
							<span class="text-danger text-sm">{{ errors.first("calculation") }}</span>
						</template>
					</CalculatorFieldConfig>
				</div>
			</form>
		</PerfectScrollbar>

		<div
			slot="footer"
			class="flex items-center sm:px-12 justify-center"
		>
			<vs-button
				@click.stop="submitData"
				class="w-full sm:w-2/5 font-bold"
			>{{ $t('Actions.Save') }}</vs-button>
		</div>
	</el-dialog>
</template>

<script>
import _ from "lodash";
import vSelect from "vue-select";
import CbsHint from "@/components/cbs-hint/CbsHint";
import CalculatorFieldConfig from "@/components/cbs-dynamic-form-config/CalculatorFieldConfig.vue";

export default {
	name: "RequestTypeStatisticalExpressionFormDialog",
	components: { vSelect, CbsHint, CalculatorFieldConfig },
	props: {
		value: {
			type: Object,
			required: true,
			validator: prop => {
				return (
					_.has(prop, "id") &&
					_.has(prop, "name") &&
					_.has(prop, "typeId") &&
					_.has(prop, "expression")
				);
			}
		},
		isDialogActive: {
			type: Boolean,
			required: true
		},
		formFields: {
			type: Array,
			required: true,
			validator: prop => prop.every(item => _.has(item, "id") && _.has(item, "name") && _.has(item, "typeId"))
		}
	},
	emits: {
		onSubmit: {
			required: true
		},
		closeDialog: {
			required: true
		}
	},
	data() {
		return {
			initFormData: {},
			isFormDirty: false
		};
	},
	computed: {
		isDialogActiveLocal: {
			get() {
				return this.isDialogActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeDialog");
				}
			}
		},
		statisticalExpressionTypes() {
			return this.$store.state.requestTypeConfig.generalData.statistic_expression_types || [];
		}
	},
	watch: {
		value: {
			handler: function() {
				this.isFormDirty = JSON.stringify(this.value) !== JSON.stringify(this.initFormData);
			},
			deep: true
		}
	},
	methods: {
		async initFetchGeneralData() {
			if(!this.$store.state.requestTypeConfig.isLoadedGeneralData) {
				try {
					this.$vs.loading();
					await this.$store.dispatch("requestTypeConfig/fetchGeneralData");
				} catch (error) {
					this.$helper.notifyError({ context: this, error });
				} finally {
					this.$nextTick(() => this.$vs.loading.close());
				}
			}
		},
		submitData() {
			this.$validator.validateAll().then(result => {
				if (result) {
					this.$emit("onSubmit");
				}
			});
		},
		handleBeforeCloseDialog(setDialogHide) {
			this.handleCloseDialog(() => {
				setDialogHide();
			}, this.isFormDirty);
		},
	},
	created() {
		this.initFetchGeneralData();
		this.initFormData = Object.assign({}, this.value);
	}
};
</script>
